import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useDayforceJobsIssuesContextValue } from '../context/DayforceJobsIssuesProvider'

export const DayforceJobsIssuesHeader = () => {
  const { state, actions } = useDayforceJobsIssuesContextValue()

  return (
    <Header
      title="Dayforce Jobs Issues"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
